export enum PdfViewerAppearanceMode {
  DEFAULT = '',
  SIMPLIFIED = 'simplified'
}
